module.exports = __webpack_public_path__ + "static/media/48364307_2308751312533380_6035712958338695168_o-thumb.3cc1e75c.jpg";